import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <section id="about" className="py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h2 className="section-title text-center">About My Work</h2>
            <p className="section-subtitle text-center">
              Building scalable systems and solving complex engineering challenges
            </p>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col lg={6} className="mb-4">
            <div className="p-4">
              <h3 className="h4 fw-bold mb-3">Engineering Excellence</h3>
              <p className="text-muted">
                With deep expertise in Java, Spring Boot, and modern backend technologies, I design and
                implement systems that are robust, maintainable, and built to last. My approach combines
                technical mastery with pragmatic problem-solving.
              </p>
              <p className="text-muted">
                Every project is an opportunity to deliver exceptional value—whether it's architecting
                microservices, optimizing performance, or building APIs that power critical business operations.
              </p>
            </div>
          </Col>
          <Col lg={6} className="mb-4">
            <div className="p-4">
              <h3 className="h4 fw-bold mb-3">Problem-Solving Approach</h3>
              <p className="text-muted">
                I don't just write code—I solve problems. My process starts with understanding your business
                goals, then translating them into technical solutions that are scalable, secure, and efficient.
              </p>
              <p className="text-muted">
                From system design to deployment, I handle the full lifecycle with attention to detail,
                clean code practices, and a commitment to delivering production-ready software that exceeds
                expectations.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg={12}>
            <div className="bg-light p-5 rounded-3">
              <Row>
                <Col md={3} className="text-center mb-3">
                  <h3 className="display-6 fw-bold text-primary">5+</h3>
                  <p className="text-muted mb-0">Years Experience</p>
                </Col>
                <Col md={3} className="text-center mb-3">
                  <h3 className="display-6 fw-bold text-primary">20+</h3>
                  <p className="text-muted mb-0">Projects Delivered</p>
                </Col>
                <Col md={3} className="text-center mb-3">
                  <h3 className="display-6 fw-bold text-primary">100%</h3>
                  <p className="text-muted mb-0">Client Satisfaction</p>
                </Col>
                <Col md={3} className="text-center mb-3">
                  <h3 className="display-6 fw-bold text-primary">24/7</h3>
                  <p className="text-muted mb-0">Support Available</p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;